import React, { Component } from 'react';
import { Form, Input, Button, Alert, Icon } from 'antd';
import { Redirect, Link } from 'react-router-dom';

import * as authService from '../services/authService';

class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: '',
      password: '',
      error: null,
      loading: false,
    };
  }

  handleSubmit = async (e) => {
    e.preventDefault();
    this.setState({ loading: true, error: null });

    try {
      const data = await authService.login(this.state.email, this.state.password);
      if (data.success && this.props.onLogin) {
        this.props.onLogin(data.user);
      }
    } catch (err) {
      this.setState({ error: err.message || 'Login failed' });
    } finally {
      this.setState({ loading: false });
    }
  };

  render() {
    if (this.props.user) {
      return <Redirect to="/results" />;
    }

    const { error, loading } = this.state;

    const inputStyle = {
      height: 48,
      borderRadius: 8,
      border: '1px solid #e2e8f0',
      fontSize: 14,
    };

    return (
      <div style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'linear-gradient(135deg, #1e1b4b 0%, #312e81 100%)',
        marginLeft: 200,
      }}>
        <div style={{
          background: '#fff',
          borderRadius: 16,
          padding: '48px 40px',
          width: '100%',
          maxWidth: 420,
          boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)',
        }}>
          <div style={{ textAlign: 'center', marginBottom: 32 }}>
            <div style={{
              width: 64,
              height: 64,
              background: 'linear-gradient(135deg, #a78bfa 0%, #8b5cf6 100%)',
              borderRadius: 16,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              margin: '0 auto 20px',
              boxShadow: '0 10px 40px rgba(139, 92, 246, 0.3)',
            }}>
              <Icon type="lock" style={{ fontSize: 28, color: '#fff' }} />
            </div>
            <h2 style={{
              margin: 0,
              fontSize: 24,
              fontWeight: 700,
              color: '#1e293b',
            }}>
              Welcome back
            </h2>
            <p style={{
              margin: '8px 0 0',
              color: '#64748b',
              fontSize: 14,
            }}>
              Sign in to access ELF DIGEST
            </p>
          </div>

          {error && (
            <Alert
              message={error}
              type="error"
              showIcon
              style={{ marginBottom: 24 }}
            />
          )}

          <Form onSubmit={this.handleSubmit}>
            <div style={{ marginBottom: 20 }}>
              <label style={{
                display: 'block',
                marginBottom: 8,
                fontWeight: 500,
                fontSize: 14,
                color: '#374151',
              }}>
                Email address
              </label>
              <Input
                prefix={<Icon type="mail" style={{ color: '#94a3b8' }} />}
                placeholder="you@example.com"
                type="email"
                value={this.state.email}
                onChange={e => this.setState({ email: e.target.value })}
                style={inputStyle}
              />
            </div>

            <div style={{ marginBottom: 28 }}>
              <label style={{
                display: 'block',
                marginBottom: 8,
                fontWeight: 500,
                fontSize: 14,
                color: '#374151',
              }}>
                Password
              </label>
              <Input.Password
                prefix={<Icon type="lock" style={{ color: '#94a3b8' }} />}
                placeholder="Enter your password"
                value={this.state.password}
                onChange={e => this.setState({ password: e.target.value })}
                style={inputStyle}
              />
            </div>

            <Button
              type="primary"
              htmlType="submit"
              loading={loading}
              block
              style={{
                height: 48,
                fontSize: 16,
                fontWeight: 600,
                borderRadius: 8,
                background: 'linear-gradient(135deg, #a78bfa 0%, #8b5cf6 100%)',
                border: 'none',
                boxShadow: '0 4px 14px rgba(139, 92, 246, 0.4)',
              }}
            >
              {loading ? 'Signing in...' : 'Sign in'}
            </Button>
          </Form>

          <p style={{
            textAlign: 'center',
            marginTop: 24,
            color: '#64748b',
            fontSize: 13,
          }}>
            Need an account?{' '}
            <Link to="/about" style={{ color: '#8b5cf6', fontWeight: 500 }}>
              Learn how to register
            </Link>
          </p>
        </div>
      </div>
    );
  }
}

export default Login;
